

import React from "react";
import {Route, Switch} from "react-router-dom";
import PriceCalculatorList from "./PriceCalculatorList";
import PriceCalculatorDetails from "./PriceCalculatorDetails";

const App = ({match}) => (
    <Switch>
      <Route exact path={`${match.url}`} component={PriceCalculatorList}/>
       <Route path={`${match.url}/details/:calculationId?`} component={PriceCalculatorDetails}/>
    </Switch>
);

export default App;